export type OperationalEvent =
  | 'verification_started'
  | 'verification_completed'
  | 'verification_failed'
  | 'signal_type_detected'
  | 'unsupported_format';

/**
 * Local-only event seam. R1 has no analytics destination. Payloads are deliberately
 * restricted so future wiring cannot accidentally include filenames, hashes, or metadata.
 */
export function emitOperationalEvent(
  name: OperationalEvent,
  data: { durationBucket?: '<1s' | '1-3s' | '3-10s' | '10s+'; signalType?: string } = {},
): void {
  globalThis.dispatchEvent(new CustomEvent('upl:operational-event', { detail: { name, ...data } }));
}

export function durationBucket(milliseconds: number): '<1s' | '1-3s' | '3-10s' | '10s+' {
  if (milliseconds < 1000) return '<1s';
  if (milliseconds < 3000) return '1-3s';
  if (milliseconds < 10_000) return '3-10s';
  return '10s+';
}
